import { useMemo } from "react";
import type { FareDetailsV2, TripDetailsV2 } from "@b2bportal/air-shopping-api";
import {
  CallState,
  type FlightFaresSourceResult,
  type FlightFareMeta,
  type UseFlightFaresSource,
} from "@b2bportal/core-types";
import { FlightFareView } from "@tenant/flights";

export const useFlightFaresSource: UseFlightFaresSource = ({
  trip,
}): FlightFaresSourceResult => {
  const rates = useMemo(() => {
    const faresWithId = trip.fareDetails.filter(
      (fare): fare is FareWithId => fare.id !== undefined
    );

    return faresWithId.map((fare) => createFlightFare(fare, trip));
  }, [trip]);

  return { state: CallState.Success, data: rates };
};

type FareWithId = FareDetailsV2 & { id: string };

const createFlightFare = (
  fare: FareWithId,
  trip: TripDetailsV2
): FlightFareMeta => ({
  key: `${trip.id}/${fare.id}`,
  origin: "flight",
  fareDetails: fare,
  tripDetails: trip,
  setSelectedFare: () => {},
  View: FlightFareView,
});
